import { api } from "./api";
import { callAuthApi } from "../helpers/";

const callApiFetchSaqQuestionsData = (questionType) => {
  return callAuthApi().then(() => {
    // return api.service("api/saq-questions").get("saq-a");
  });
};

export { callApiFetchSaqQuestionsData };
